<template>
  <div class="content">
    <controlbar
      :dispItems="userNotifications"
      @input-event="setUserNotifications"
      @list-reload="reload"
    >
    </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="table_checkbox">
            <input
              type="checkbox"
              class="checkbox"
              :checked="checked"
              @click="allCheckedAction"
            />
          </th>
          <td class="table_contents">
            <label class="name_label">
              {{ titleLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="start_label">
              {{ startLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="end_label">
              {{ endLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispNotification in userNotifications"
            :key="dispNotification.id"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="dispNotification.checked"
                @click="checkedAction(dispNotification)"
              />
            </th>
            <td class="table_contents" @click="setActive(dispNotification)">
              <label>
                {{ dispNotification.title }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispNotification)">
              <label>
                {{ formatedDate(dispNotification.startDateTime) }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispNotification)">
              <label>
                {{ formatedDate(dispNotification.endDateTime) }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setUserNotifications(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import Pagination from 'vue-pagination-2'

export default {
  data() {
    return {
      titleLabel: 'タイトル',
      startLabel: '開始日時',
      endLabel: '終了日時',
      showFalseModal: false,
      showCompleteModal: false,
      windowHeight: '',
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0
    }
  },
  computed: {
    userNotifications() {
      return this.$store.state.userNotification.userNotifications
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.userNotification.total
      ) {
        return this.$store.state.userNotification.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >=
        this.$store.state.userNotification.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.userNotification.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('userNotification/clearSelectedUserNotificationList')
    this.$store.state.prevPageNo = 0
    this.setUserNotifications(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    falseModalWindow,
    loadingModalWindow,
    Pagination
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.userNotifications.length; i++) {
        this.userNotifications[i].checked = this.checked
      }
      this.$store.dispatch(
        'userNotification/updateSelectedUserNotificationList',
        this.userNotifications
      )
    },
    checkedAction(userNotification) {
      userNotification.checked = !userNotification.checked
      this.$store.dispatch(
        'userNotification/updateSelectedUserNotificationList',
        [userNotification]
      )
    },
    close(e) {
      this.showFalseModal = false
      this.showCompleteModal = false
    },
    async reload() {
      this.$store.dispatch('userNotification/clearSelectedUserNotificationList')
      await this.setUserNotifications(this.$store.state.prevPageNo)
    },
    async setUserNotifications(pageNo) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        await this.$store.dispatch('userNotification/setUserNotifications', {
          pageNo: pageNo
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
        this.$store.state.prevPageNo = pageNo
        this.checked = false
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 3
        let reason = 'MSGCRC0320'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0320.name +
            this.errorMsg.MSGCRC0320.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch(
          'userNotification/setDetailUserNotification',
          payload
        )
        if (location.pathname !== '/userNotification/detail') {
          this.$router.push('../userNotification/detail')
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_730001
        let eventType = 3
        let reason = 'MSGCRC0321'
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0321.name +
            this.errorMsg.MSGCRC0321.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    formatedDate(unixTime) {
      const targetDate = new Date(unixTime)
      return `${targetDate.getFullYear()}/${(targetDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${targetDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${targetDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${targetDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    }
  }
}
</script>
<style scoped>
td {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/userNotification/userNotificationList.vue